import React from "react";
import SVGIcon, { IconProps } from "ui/SVGIcon";

const path =
  "M13.333 0.166748H10.9997L12.1597 1.90675C12.233 2.02008 12.153 2.16675 12.0197 2.16675H10.6863C10.4663 2.16675 10.253 2.05341 10.133 1.86675L8.99967 0.166748H7.66634L8.82634 1.90675C8.89967 2.02008 8.81967 2.16675 8.68634 2.16675H7.35301C7.13301 2.16675 6.91967 2.05341 6.79967 1.86675L5.66634 0.166748H4.33301L5.49301 1.90675C5.56634 2.02008 5.48634 2.16675 5.35301 2.16675H4.01967C3.79967 2.16675 3.59301 2.05341 3.46634 1.86675L2.33301 0.166748H1.66634C0.933008 0.166748 0.339674 0.766748 0.339674 1.50008L0.333008 9.50008C0.333008 10.2334 0.933008 10.8334 1.66634 10.8334H12.333C13.0663 10.8334 13.6663 10.2334 13.6663 9.50008V0.500081C13.6663 0.313415 13.5197 0.166748 13.333 0.166748ZM6.49994 7.6667L5.6666 9.50003L4.83327 7.6667L2.99994 6.83336L4.83327 6.00003L5.6666 4.1667L6.49994 6.00003L8.33327 6.83336L6.49994 7.6667ZM9.66646 6.83352L10.2931 5.46019L11.6665 4.83352L10.2931 4.20685L9.66646 2.83352L9.03979 4.20685L7.66646 4.83352L9.03979 5.46019L9.66646 6.83352Z";

export default function VideoFilter(props: IconProps) {
  return (
    <SVGIcon
      path={path}
      {...props}
      fillRule="evenodd"
      clipRule="evenodd"
      viewBox="0 0 14 11"
    />
  );
}
